import { Injectable } from '@angular/core'
import { RouterState, RouterStateModel } from '@ngxs/router-plugin'
import { Select } from '@ngxs/store'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class RouterFacadeService {
  /** Returns the router state model */
  @Select(RouterState)
  public data$: Observable<RouterStateModel>
}
